import React from 'react';

export default function EpisodeOverviewCard({ episode }) {
  const title = episode?.title || episode?.episode_title || 'Episode not yet generated';
  const whyNow = episode?.why_now || episode?.whyNow || '';
  const threads = episode?.unresolved_threads || episode?.unresolvedThreads || [];
  const flags = episode?.caution_flags || episode?.cautionFlags || [];

  return (
    <>
      <div className="studio-section-head">
        <span>Episode</span>
        <span className="count">{episode?.id ? `#${String(episode.id).slice(0, 6)}` : 'draft'}</span>
      </div>
      <div className="studio-kv-block" data-testid="episode-overview">
        <div className="studio-kv">
          <span className="k">Title</span>
          <span className="v">{title}</span>
        </div>
        {whyNow && (
          <div className="studio-kv">
            <span className="k">Why Now</span>
            <span className="v" style={{ maxWidth: 230, whiteSpace: 'normal' }}>{whyNow}</span>
          </div>
        )}
        <div className="studio-kv">
          <span className="k">Unresolved</span>
          <span className="v" style={{ color: threads.length ? 'var(--status-elevated)' : 'var(--status-nominal)' }}>
            {threads.length}
          </span>
        </div>
        <div className="studio-kv">
          <span className="k">Caution Flags</span>
          <span className="v" style={{ color: flags.length ? 'var(--status-storm)' : 'var(--status-nominal)' }}>
            {flags.length}
          </span>
        </div>
      </div>
    </>
  );
}
